import { graphql, useStaticQuery } from "gatsby";
import { PatstoreImage } from "@types";

const SUPPORTED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];

const hasProcessableImage = (image: PatstoreImage) =>
    Boolean(
        image.localFile?.childImageSharp?.gatsbyImageData &&
            SUPPORTED_IMAGE_EXTENSIONS.includes(
                image.localFile.extension?.toLowerCase() ?? "",
            ),
    );

const useGetImage = () => {
    const data = useStaticQuery(graphql`
        query getAllImage {
            allPatstoreImage(
                filter: {
                    localFile: {
                        extension: { in: ["jpg", "jpeg", "png", "webp", "gif"] }
                    }
                }
            ) {
                edges {
                    node {
                        id
                        objectId
                        localFile {
                            extension
                            absolutePath
                            url
                            publicURL
                            childImageSharp {
                                gatsbyImageData(
                                    width: 1920
                                    placeholder: BLURRED
                                    formats: [WEBP]
                                )
                            }
                        }
                    }
                }
            }
        }
    `);

    const allImage: PatstoreImage[] =
        data.allPatstoreImage.edges
            .map((edge: { node: PatstoreImage }) => edge.node)
            .filter(hasProcessableImage) || [];

    const findImage: (id: string) => PatstoreImage | undefined = (id: string) => {
        const result = allImage.find((item: PatstoreImage) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findImage,
        images: allImage,
    };
}; 

export default useGetImage;
